import {
  FILTER_PARAM_KEY,
  FILTER_SCOPE_PARAM_KEY,
  FILTER_SCOPE_PARAM_MINE_VALUE,
  SUBMENU_PARAM_KEY,
} from '../../constants/route'
import { isRequestPreFilterMine } from '../../utils/filter'
import {
  getChatProfilePathname,
  getEmailProfilePathname,
} from '../../utils/link'
import { getWebappLinkPrefix } from '../../utils/route'

import { BirdviewCommunicationKind } from './DashboardBirdview.constants'
import { checkIsBirdviewTeamScope } from './DashboardBirdview.utils'

// `filter=mine` narrows to the user's own requests by itself.
function checkIsBirdviewPreFilterScoped({ scope, target }) {
  return (
    !checkIsBirdviewTeamScope(scope) &&
    !isRequestPreFilterMine(target.preFilter)
  )
}

// The list's default `sub` keeps `useDefaultParams` from replacing the pre-filter params.
function getBirdviewPreFilterPath({ scope, target }) {
  const searchParams = new URLSearchParams({
    ...target.rowFilters,
    [FILTER_PARAM_KEY]: target.preFilter,
    [SUBMENU_PARAM_KEY]: target.sub,
  })

  if (checkIsBirdviewPreFilterScoped({ scope, target })) {
    searchParams.set(FILTER_SCOPE_PARAM_KEY, FILTER_SCOPE_PARAM_MINE_VALUE)
  }

  return `${target.path}?${searchParams}`
}

export function checkIsBirdviewChatCommunication(kind) {
  return kind === BirdviewCommunicationKind.Chat
}

export function getBirdviewRowTarget({ id, target }) {
  return { ...target, rowFilters: { [target.rowFilterName]: id } }
}

export function getBirdviewListTarget({ availableSections, scope, target }) {
  if (!availableSections[target.sectionName]) {
    return getWebappLinkPrefix(target.webappPath ?? target.path)
  }

  return target.preFilter
    ? getBirdviewPreFilterPath({ scope, target })
    : target.path
}

export function getBirdviewCommunicationPathname({ availableSections, item }) {
  return checkIsBirdviewChatCommunication(item.kind)
    ? getChatProfilePathname({ availableSections, uuid: item.id })
    : getEmailProfilePathname({
        availableSections,
        id: item.messageId,
        singleEmailAccount: true,
      })
}
